import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlImpersonationService } from '@app/pl-core-services/pl-auth/services/pl-impersonation.service';

/**
 * Component that handles ending user impersonation.
 * Clears impersonation data from session storage and reloads the page
 * to return to the original user's session.
 */
@Component({
  selector: 'pl-end-impersonation',
  template: `
    <div class="impersonation-loading">
      <p>Ending impersonation...</p>
    </div>
  `,
  styles: [
    `
      .impersonation-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        font-size: 1.2rem;
      }
    `,
  ],
})
export class EndImpersonationComponent implements OnInit {
  constructor(
    private router: Router,
    private impersonationService: PlImpersonationService
  ) {}

  ngOnInit(): void {
    // Clear all impersonation-related data
    this.impersonationService.stop();

    // Reload the page to restore the original user's session
    window.location.href = '/';
  }
}
